import { useMutation } from 'react-query';
import postContactUs from 'api/services/postContucUs';

const usePostContactUs = () => {
  const { mutate, error } = useMutation(async ({ feedback }) => {
    await postContactUs({ feedback, subject: 'subject' });
  });
  return {
    mutate,
    error,
  };
};

export default usePostContactUs;
